const numberSorter = (a: string, b: string) => {
  const aVal = Number(a);
  const bVal = Number(b);
  if (aVal > bVal) {
    return [1, -1];
  }
  return [-1, 1];
};
export default numberSorter;
